function getHubSpotFormWrapperFromEvent(event) {
  if (!window.HubspotFormsV4) return null;

  const form = HubspotFormsV4.getFormFromEvent(event);
  if (!form) return null;

  return document.getElementById(form.getInstanceId());
}

// Hide 1Password icon
window.addEventListener('hs-form-event:on-ready', event => {
  const wrapper = getHubSpotFormWrapperFromEvent(event);
  if (!wrapper?.classList.contains('hs-newsletter')) return;

  wrapper.querySelectorAll('.hsfc-TextInput').forEach(el => {
    el.setAttribute('data-1p-ignore', '');
  });
});

window.addEventListener('hs-form-event:on-submission:success', event => {
  const wrapper = getHubSpotFormWrapperFromEvent(event);
  if (!wrapper) return;

  wrapper.classList.remove('submission-failed');
  wrapper.classList.add('has-submitted', 'submission-success');

  // Fix HubSpot focusing the submision success message
  // despite it not being an interactive element.
  const postSubmit = wrapper.querySelector('.hsfc-PostSubmit');

  if (postSubmit) {
    postSubmit.tabIndex = -1;
    postSubmit.blur();
  }
});

// Only show validation messages on HubSpot newsletter signup after submit
window.addEventListener('hs-form-event:on-submission:failed', event => {
  const wrapper = getHubSpotFormWrapperFromEvent(event);
  if (!wrapper) return;

  wrapper.classList.remove('submission-success');
  wrapper.classList.add('has-submitted', 'submission-failed');
});
